import { FlowGetPatientOrderBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const GetPatientOrderBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.GetPatientOrder),
  returnType: returnTypeSchema(ProducedType.PatientOrder),
  config: FlowGetPatientOrderBlockConfigSchema,
});
export type GetPatientOrderBlock = z.infer<typeof GetPatientOrderBlockSchema>;
